import React from 'react';
import { observer } from 'mobx-react';
import { computed } from 'mobx';
import { VocabDecksWrapper } from '@seedlang/hoc';
import styled from '@emotion/styled';
import DeckLink from 'components/deck/deck_link';
import DeckLinkIconWrapper from 'components/deck/deck_link_icon_wrapper';
import { AppUI } from '@seedlang/state';
import { CompassIcon, CubeIcon, HandshakeIcon, JigsawIcon, NumbersOutlineIcon, PluralOutlineIcon } from '@seedlang/icons';
import { isPresent, pixify } from '@seedlang/utils';
import Modal from 'components/modal';
import VocabOptions from 'components/vocab/vocab_options';

const Wrapper = styled.div`
  position: relative;
  display: flex;
  flex: 1;
  padding: ${props => props.isMobile ? 0 : '0 10px 10px'};
  width: ${props => props.width};
  max-height: ${props => props.maxHeight};
  background: #FFF;
  border-bottom-left-radius: 10px;
  border-bottom-right-radius: 10px;
  justify-content: center;
  box-sizing: border-box;
`;

const DeckRow = styled.div`
  display: flex;
  max-width: ${props => props.maxWidth};
  overflow: auto;
  min-height: ${props => props.minHeight};
  align-items: center;
  justify-content: ${props => props.justifyContent};
  padding: ${props => props.padding};
  flex-wrap: wrap;
`;

const Aa = styled.div`
  font-size: 33px;
  color: #FFF;
`;

@observer
class VocabDecks extends React.Component {

  @computed get deck_width() {
    return AppUI.layout.viewportWidth < 430 ? (AppUI.layout.viewportWidth / 2) - 25 : 190;
  }

  @computed get widthGreaterThanDecks() {
    const deckLinksWidth = AppUI.targetLanguageId === 'DE' ? 1210 : 810;
    return AppUI.layout.leftColumnWidth > deckLinksWidth;
  }

  @computed get mobileHeight() {
    if (isPresent(this.props.searchQuery)) {
      return AppUI.layout.mobileContentHeight - 165;
    }
    return AppUI.layout.mobileContentHeight - 220;
  }

  getIconComponent(iconName) {
    const icons = {
      CompassIcon,
      CubeIcon,
      HandshakeIcon,
      JigsawIcon,
      PluralOutlineIcon,
      NumbersOutlineIcon,
    };
    return icons[iconName];
  }

  render() {
    return (
      <Wrapper
        isMobile={AppUI.layout.isMobile}
        width='100%'
        maxHeight={AppUI.layout.isMobile ? pixify(this.mobileHeight) : null}
      >
        {
          AppUI.showVocabModal &&
          <Modal
            onCloseModal={() => AppUI.set('showVocabModal', null)}
            top={AppUI.layout.isMobile ? '60px' : '100px'}
            width={pixify(AppUI.layout.defaultModalWidth)}
            gradient
            title={this.props.modalTitle}
          >
            <VocabOptions
              onSetFilter={this.props.onSetFilter}
              filterSettings={this.props.filterSettings}
              type={AppUI.showVocabModal}
              filters={this.props.filters}
              selectedWordIds={this.props.selectedWordIds}
              trainerIsCompleted={this.props.progress[AppUI.showVocabModal]['current'] === this.props.progress[AppUI.showVocabModal]['total']}
            />
          </Modal>
        }
        <DeckRow
          justifyContent='center'
          minHeight={AppUI.layout.isMobile ? this.mobileHeight : null}
          maxWidth={AppUI.layout.viewportWidth > 4 * (this.deck_width + 10) && AppUI.targetLanguageId === 'DE' ? '90%' : '100%'}
          padding='5px'
        >
          {
            this.props.deckConfig.map(config => {
              const shouldShow = !config.onlyForGerman || (AppUI.targetLanguageId === 'DE' || !AppUI.targetLanguageId);
              if (!shouldShow) {
                return null;
              }

              return (
                <DeckLink
                  key={config.type}
                  overTitle='Practice'
                  title={config.title}
                  borderColor={config.disabled ? '#777' : config.borderColor}
                  width={this.deck_width}
                  marginRight='10px'
                  onClick={() => this.props.onClick(config.type)}
                  progressCurrent={config.progress.current}
                  progressTotal={config.progress.total}
                  progressLabel={config.progressLabel}
                  disabled={config.disabled}
                  showLockIcon={config.useDisabledProp ? undefined : config.disabled}
                  new={config.showNewLabel}
                >
                  <DeckLinkIconWrapper
                    showLockIcon={config.disabled}
                    disabled={config.disabled}
                    iconWidth={`${config.iconWidth}px`}
                    width={this.deck_width - 10}
                    widthOffsets={[10, 60, 100]}
                    background={config.background}
                    backgroundColors={config.background ? undefined : (config.webBackgroundColors || config.backgroundColors)}
                    iconMarginTop={config.webIconMarginTop !== undefined ? config.webIconMarginTop : (config.iconMarginTop !== undefined ? `${config.iconMarginTop}px` : undefined)}
                    iconMarginLeft={config.webIconMarginLeft !== undefined ? config.webIconMarginLeft : (config.iconMarginLeft !== undefined ? `${config.iconMarginLeft}px` : undefined)}
                  >
                    {
                      config.iconType === 'text' ?
                        <Aa>
                          Aa
                        </Aa>
                        :
                        (() => {
                          const IconComponent = this.getIconComponent(config.iconName);
                          return <IconComponent />;
                        })()
                    }
                  </DeckLinkIconWrapper>
                </DeckLink>
              );
            })
          }
        </DeckRow>
      </Wrapper >
    );
  }
}

export default VocabDecksWrapper(VocabDecks);
